import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getLessonPlans } from '../../../../../store/actions/course';
import styles from './styles.module.css';
import { toast } from 'react-toastify';

const AddLessonModal = (props) => {
    const { setAddlessonModal } = props;
    const dispatch = useDispatch();
    const [lessonPlans, setLessonPlans] = useState([]);
    const [selectedLesson, setSelectedLesson] = useState(null);

    useEffect(() => {
        const fetchLessons = async () => {
            const profile = JSON.parse(localStorage.getItem("profile"));
            if (profile?._id) {
                const res = await dispatch(getLessonPlans(profile._id));
                if (res?.data) {
                    setLessonPlans(res.data);
                }
            }
        };
        fetchLessons();
    }, [dispatch]);

    const handleSubmit = async () => {
        if (!selectedLesson) return toast.warn("Please select a lesson plan");
        toast.info(`Linking Lesson: ${selectedLesson.title?.data || selectedLesson.title}`);
        setAddlessonModal(false);
    };

    const getImageSrc = (item) => {
        return (typeof item.courseImage === "string" ? item.courseImage : item.courseImage?.data) ||
            (typeof item.coverImage === "string" ? item.coverImage : item.coverImage?.data) ||
            "https://via.placeholder.com/40";
    };

    return (
        <div className={styles.modalBackdrop}>
            <div className={styles.modal} style={{ width: '600px' }}>
                <div
                    className={styles.closeBtn}
                    onClick={() => { setAddlessonModal(false) }}
                >
                    <i className="fas fa-close"></i>
                </div>
                <h2 className={styles.modalHeading}>Add Lesson Plan</h2>

                <div className={styles.modalBody} style={{ maxHeight: '50vh', overflowY: 'auto', paddingRight: '0.5rem' }}>
                    {lessonPlans.length > 0 ? (
                        lessonPlans.map((item, index) => (
                            <div
                                key={index}
                                onClick={() => setSelectedLesson(item)}
                                className={styles.summaryBox}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '1.25rem',
                                    cursor: 'pointer',
                                    border: selectedLesson?._id === item._id ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                                    backgroundColor: selectedLesson?._id === item._id ? '#eff6ff' : '#f8fafc',
                                    transition: 'all 0.2s ease',
                                    margin: '0.75rem 0'
                                }}
                            >
                                <img
                                    src={getImageSrc(item)}
                                    alt="lesson_img"
                                    style={{ width: '48px', height: '48px', borderRadius: '12px', objectFit: 'cover', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                                />
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: '1rem', color: '#1e293b', fontWeight: '700' }}>
                                        {item.title?.data || item.title || "Untitled"}
                                    </div>
                                    <div style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '2px' }}>
                                        {item.description?.data || item.description || "No description provided"}
                                    </div>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: '800', textTransform: 'uppercase', marginBottom: '4px' }}>Status</div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.875rem', fontWeight: '600', color: item.isVerified ? '#10b981' : '#64748b' }}>
                                        {item.isVerified ? "Verified" : "Pending"}
                                        <i className={`fas fa-${item.isVerified ? 'check-circle' : 'clock'}`}></i>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className={styles.summaryBox} style={{ textAlign: 'center', padding: '3rem' }}>
                            <i className="fas fa-folder-open" style={{ fontSize: '2rem', color: '#cbd5e1', marginBottom: '1rem' }}></i>
                            <p style={{ margin: 0, color: '#64748b' }}>No Lesson Plans found. Create one in Courses tab first.</p>
                        </div>
                    )}
                </div>

                <div className={styles.actionArea}>
                    <button
                        className={styles.secondaryBtn}
                        onClick={() => setAddlessonModal(false)}
                    >
                        Cancel
                    </button>
                    <button
                        className={styles.primaryBtn}
                        onClick={handleSubmit}
                        disabled={!selectedLesson}
                    >
                        Link Lesson Plan
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddLessonModal;
